<template>
<div>
  <section class="hero is-primary" id="head-section">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="title">欢迎使用</h2>
      </div>
    </div>
  </section>

</div>
</template>

<script>
export default {
  beforeMount () {
    if (process.env.NODE_ENV === 'production') {
      this.$store.dispatch('startWxOAuth')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Welcome.vue